import Eonnahome1 from '../../Media/homeimages/Eonna Aerra 10.webp'
import Eonnahome2 from '../../Media/homeimages/Eonna Aerra 10.webp'





const Eonnahomeimages =[
Eonnahome1,Eonnahome2
]

export default Eonnahomeimages;